import { buildGet } from 'api/builders';

export const index = (dispatch) => buildGet({
  url: 'sign_up/api/account/',
  dispatch,
});
